import {
  Button,
  Container,
  Modal,
  Span,
  Text,
  useModal,
} from "@fluidattacks/design";
import { Trans, useTranslation } from "react-i18next";

interface IUpgradeSuccessModalProps {
  readonly onClose: () => void;
}

const UpgradeSuccessModal = ({
  onClose,
}: IUpgradeSuccessModalProps): JSX.Element => {
  const { t } = useTranslation();
  const prefix = "upgrade.success.modal.";
  const modalRef = useModal("upgrade-groups-modal");

  return (
    <Modal
      modalRef={{ ...modalRef, close: onClose, isOpen: true }}
      size={"sm"}
      title={t(`${prefix}title`)}
    >
      <Container mb={5}>
        <Trans
          components={{
            bold: (
              <Span fontWeight={"bold"} size={"md"}>
                {undefined}
              </Span>
            ),
          }}
          i18nKey={`${prefix}text`}
          t={t}
        />
        <Text my={1} size={"md"}>
          {t(`${prefix}description`)}
        </Text>
      </Container>
      <Button onClick={onClose} width={"50%"}>
        {"Got it!"}
      </Button>
    </Modal>
  );
};

export { UpgradeSuccessModal };
